import cn from "../../../../utils/classes"
import useIsMobile from "../../hooks/useIsMobile"

interface TableHeader extends React.ThHTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode
}

export const TableHeader: React.FC<TableHeader> = ({ children, ...props }) => {
  const isMobile = useIsMobile()
  const className = cn(
    "align-middle text-left px-[16px] py-[8px] min-w-[117px] border-solid border-0 !border-b-[1px] border-gray-200 font-medium text-gray-700 bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#2198CC] focus-visible:rounded-lg",
    isMobile ? "h-[31px]" : "h-[50px]",
    props.className,
  )
  return (
    <th {...props} className={className}>
      {children}
    </th>
  )
}
